module.exports = __webpack_public_path__ + "static/mobile-dna-a3648dc1b890836de76a4873201b7e41.png";